import axios from "axios";
import { apiUrl } from "../constant";

const API_REPORT_BASE = `${apiUrl}/api/CarrierReports`;
/* istanbul ignore next */
export const getReconciliationReportService = (data) => {
    return axios.post(`${API_REPORT_BASE}/get-reconciliation-monthly-report`, data);
};
/* istanbul ignore next */
export const getReconciliationTransactionDetailsService = (data) => {
    return axios.post(`${API_REPORT_BASE}/get-reconciliation-transaction-details`, data);
};

export const getReconciliationMonthlyStatusService = (data) => {
    return axios.post(`${API_REPORT_BASE}/get-reconciliation-monthly-statement-report`, data);
};